<template>
  <div>
    <router-link 
        class="btn btn-small btn-secondary"
        :to="{ name: 'Devices' }"
    >
    Back to device list
    </router-link>
    <div class="d-flex flex-column flex-sm-row align-items-center justify-content-center">
      <h2>Video stream for {{ device.name }}</h2>
    </div>
    <div>
      <div class="d-flex flex-column flex-sm-row justify-content-center camera-feed">
        <div v-if="isLoading" role="status">
          <!-- animate flashing gray -->
          <div id="loading-box"></div>
        </div>
        <img id="camera-feed-img" :src="cameraFeedUrl" @load="handleLoad" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as api from '../../store/api';

export default {
  props: ['device_id'],
  data: () => ({
    isLoading: true,
    fetchImgInterval: null,
  }),
  computed: {
    ...mapGetters({
      device: 'singleDevice'
    }),
    cameraFeedUrl() {
      return `${api.instance.defaults.baseURL}/video_feed/${this.device_id}`;
    },
  },
  methods: {
    handleLoad() {
      this.isLoading = false;
    },
    fetchImg() {
      fetch(this.cameraFeedUrl, {
        headers: {"Authorization": "Bearer " + $cookies.get('jwt')} 
      })
      .then(response => {
        return response.blob();
      })
      .then((imageBlob) => {
        var objectURL = URL.createObjectURL(imageBlob);
        
        var newImg = new Image();
        newImg.onload = () => {
          document.getElementById('camera-feed-img').src = objectURL;
        };
        newImg.src = objectURL;
      })
      .catch((error) => {
        console.log(error);
      });
    },
  },
  created() {
    this.$store.dispatch('getDevice', this.device_id);
    this.fetchImgInterval = setInterval(() => {
        this.fetchImg();
      }, 2000);
  },
  beforeDestroy() {
    clearInterval(this.fetchImgInterval);
  },
}
</script>

<style scoped>
#loading-box {
  width: 640px;
  height: 360px;
  background: linear-gradient(90deg, #909090, #BEBEBE, #909090);
  background-size: 200% 100%;
  animation: pulse-animation 3s infinite;
}

@keyframes pulse-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.camera-feed img {
  max-width: 100%;
  height: auto;
}

.camera-feed {
  margin-top: 1rem;
  width: auto;
}
</style>
